import { render, staticRenderFns } from "./ai_my_betting.vue?vue&type=template&id=2b3efebe&scoped=true&"
import script from "./ai_my_betting.vue?vue&type=script&lang=js&"
export * from "./ai_my_betting.vue?vue&type=script&lang=js&"
import style0 from "./ai_my_betting.vue?vue&type=style&index=0&id=2b3efebe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3efebe",
  null
  
)

export default component.exports